(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("StreamrClient", [], factory);
	else if(typeof exports === 'object')
		exports["StreamrClient"] = factory();
	else
		root["StreamrClient"] = factory();
})(globalThis, () => {
return 